import React from 'react';
import PropTypes from 'prop-types';

export class MetricCounter extends React.PureComponent {
  getMetricLine(metric) {
    return metric.line;
  }

  getText(metric) {
    const styles = {
      color: metric.color,
    };

    return (
      <div className="metric-counter-text-wrapper">
        <div className="metric-text">{metric.name}</div>
        <div className="metric-value" style={styles}>{metric.value}</div>
      </div>);
  }

  render() {
    const metricList = this.props.metrics.map(metric => (
      <div className="metric-entry" key={metric.name}>
        <div className={`inline-block metric-color-line ${this.getMetricLine(metric)}`} />
        {this.getText(metric)}
      </div>));
    return (
      <div className="metric-counter-container">
        {metricList}
      </div>
    );
  }
}

MetricCounter.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    line: PropTypes.string,
  })).isRequired,
};
